import React, { useContext, useState } from 'react';

import { zPositions } from '@/constants';
import { AuthContext } from 'contexts';
import { Text, Title, UserSelect } from 'components';
import { useContactState, useContactModalState } from './hooks';
import { ImportanceType } from './types';
import { ContactImportanceSelect } from './components';
import ContactTypeSelect from './ContactTypeSelect';
import {
  StyledDetailSectionContainer,
  StyledDetailInputsContainer,
} from './styled';

const AgentInputs = () => {
  const [error, setError] = useState(null);
  const [contactState, updateContactState] = useContactState();
  const [{ isProfile, userId, listing }] = useContactModalState();
  const { auth } = useContext(AuthContext);

  const { contactId, rep, importance, name } = contactState;

  const handleOnImportanceChange = (value: ImportanceType) => {
    updateContactState({ importance: value });
  };

  const handleOnAgentSelect = (value: string[]) => {
    setError('');
    if (isProfile) {
      if (auth?.id === value[0]) {
        setError('Cannot add yourself as a default contact');
        return;
      }
      if (userId === value[0]) {
        setError('Cannot add a user to its own default contacts');
        return;
      }
    }

    updateContactState({ rep: value[0] });
  };

  const agentInputLabel = 'Select Agent';

  return (
    <StyledDetailSectionContainer>
      <StyledDetailInputsContainer>
        <ContactTypeSelect />
        <ContactImportanceSelect
          value={importance}
          onChange={handleOnImportanceChange}
        />
      </StyledDetailInputsContainer>
      {contactId ? (
        <div>
          <Text strong dataCy={'select-agent-title'}>
            {agentInputLabel}
          </Text>
          {name && (
            <Title level={2} data-cy={'agent-name-title'}>
              {name}
            </Title>
          )}
        </div>
      ) : (
        <UserSelect
          label={agentInputLabel}
          value={[rep]}
          zIndex={zPositions.contactModalComponents}
          onChange={handleOnAgentSelect}
          optionLabelProp="label"
          error={error}
          backEndFilter="showingConfig"
          targetUserIds={listing.repsObjectIds}
          showSearch
          data-cy={'edit-contact-select-agent'}
        />
      )}
    </StyledDetailSectionContainer>
  );
};

export default AgentInputs;
